// 西班牙
export default {
    dialog: {
        msgShow: "Notificación",
        buttonOk: 'OK',
        buttonCancel: 'Cancelar',
    },
    photoBrowser: {
        bannerPhotoBrowser: 'Cerrar'
    },
    employeeNumber: 'Técnico ID',
    pleaseEnterEmployeeNumber: 'Introduzca Técnico ID',
    password: 'Contraseña',
    pleaseEnterPassword: 'Introducir contraseña',
    login: 'Iniciar la sesión',
    required: 'Requerido',
    synchronize: 'Sincroniza',
    salesOrder: 'Reporte servicio',
    pleaseEnterHome: 'Add Nomb. cliente, No. reporte, Cod. Maqui',
    searchFilter: 'Filtro de búsqueda',
    machineSpecifications: 'Especificación y modelo',
    processingStatus: 'Estado del caso',
    processing: 'En proceso',
    finish: 'Completo',
    waitCountermeasures: 'Esperar repar.',
    reset: 'Devolver',
    submit: 'Enviado',
    muMachineInvestigation: 'Utilización de maquinaria',
    logout: 'Cerrar sesión',
    searchDate: 'Búsqueda fecha',
    time: 'Búsqueda tiempo',
    basicInformation: 'Datos de los clientes',
    addSalesOrder: 'Reporte servicio',
    save: 'Guardar',
    date: 'Fecha',
    pleaseSelectDate: 'Seleccionar fecha',
    travelNumber: 'Archivo de reporte servicio',
    pleaseEnterTravelNumber: 'Ingrese No. del archivo reporte servicio',
    customerCode: 'Código de cliente',
    pleaseEnterCustomerCode: 'Introduce el código de cliente',
    customerName: 'Nombre del cliente',
    pleaseEnterCustomerName: 'Introduzca el nombre del cliente',
    country: 'Área del país',
    pleaseEnterCountry: 'Ingrese al área del país',
    customerAddress: 'Dirección del cliente',
    pleaseEnterAddress: 'Introduzca la dirección del cliente',
    customerContact: 'Persona de contacto',
    pleaseEnterContact: 'Introduzca contacto del cliente',
    salesRepresentative: 'Representante de ventas',
    pleaseEnterSalesRepresentative: 'Ingrese representante de ventas',
    hint: 'Notificación',
    createDate: 'Fecha de establecimiento',
    salesOrderNumber: 'No. de archivo reporte',
    customerSatisfaction: 'Satisfacción del cliente',
    maintenancePersonnel: 'Técnico',
    maintenanceTime: 'Tiempo de servicio',
    customerConfirmation: 'Confirmación del cliente',
    copy: 'Copiar',
    delete: 'Borrar',
    recordTime: 'Tiempo record',
    machineNumber: 'No. máquina',
    copyToSalesOrder: 'Copiar en',
    copyTo: 'Copiar a',
    selectSalesOrderNumber: 'Seleccionar archivo de reporte servicio',
    pleaseEnterSalesOrderNumber: 'Ingrese No. de reporte servicio',
    latitudeAndLongitude: 'Latitud y Longitud',
    startMaintenance: 'Iniciar servicio',
    endMaintenance: 'Finalizar servicio',
    newMachine: 'Repoete de instalación',
    maintenance: 'Reparacion de máquina',
    addMachineServiceOrder: 'Agregar archivo de reporte servicio máquina',
    selectType: 'Seleccione tipo',
    generalMaintenance: 'Reparacion de maquinas',
    oilEducationTraining: 'Entrenamiento de ACEITE',
    pleaseEnterMachineNumber: 'Introduzca el número de máquina.',
    manufacturingDate: 'Fecha de fabricación',
    pleaseSelectManufacturingDate: 'Seleccionar fecha de fabricación',
    maintenanceWarranty: 'Servicio en garantía (un año)',
    underWarranty: 'Servicio en periodo de garantía',
    warrantyExpired: 'Garantía caducada',
    confirm: 'OK',
    cancel: 'Cancelar',
    addMaintenancePersonnel: 'Agregar el nombre del técnico',
    maintenanceTimeTotal: 'Tiempo total de servicio',
    day: 'Días',
    hour: 'Horas',
    enterFactory: 'Iniciar el servicio',
    pleaseSelectEnterFactory: 'Seleccione iniciar servicio',
    longitude: 'Longitud',
    // pleaseEnterLongitude: 'Ingresa la latitud Por favor',
    latitude: 'Latitud',
    // pleaseEnterLatitude: '請輸入緯度',
    leaveFactory: 'Ingrese longitud Por favor',
    pleaseSelectLeaveFactory: 'Seleccione finalizar servicio Por favor',
    duration: 'Tiempo de servicio',
    pleaseEnter: 'Por favor entre',
    selectTime: 'Seleccione fecha y hora seleccione',
    selectSatisfaction: 'La satisfacción del cliente',
    verySatisfied: 'Muy Satisfecho',
    satisfied: 'Satisfecho',
    ordinary: 'Ordinario',
    dissatisfied: 'Descontento',
    veryDissatisfied: 'Muy descontento',
    opinionReply: 'Comentarios del cliente',
    takePhoto: 'Tomar fotografías',
    uploadFile: 'Subir archivo',
    audio: 'Archivo de audio',
    video: 'Archivo de vídeo',
    electronicSignature: 'Firma del cliente',
    signatureDate: 'Fecha de firma',
    clear: 'Borrar',
    machineInformation: 'Datos del máquina',
    machineFunction: 'Revision maquinaria',
    organizationArrangement: 'Estructura, patrón',
    spareParts: 'Partes',
    operationProcedure: 'Registro del prueba',
    problemHandling: 'Proceso',
    trainee: 'Aprendiz',
    coursePlan: 'Plan de curso',
    courseSchedule: 'Calendario de cursos',
    inputVoltageAndCurrent: 'Introduzca voltaje/amperio',
    lowSpeed: 'Velocidad baja',
    highSpeed: 'Velocidad alta',
    accelerationDecelerationSlope: 'Acc./Dic. rampa',
    acceleration: 'Acc. rampa',
    deceleration: 'Desacc. Rampa',
    clothRoller: 'Plegador',
    left: 'Izquierda',
    center: 'Medio',
    right: 'Derecha',
    yarnFeedingTeeth: 'Engranaje',
    saddleRingDistance: 'Dist. anillo y marco de soporte de leva',
    yarnNozzleNumber: 'Portador de hilo',
    height: 'Altura',
    spacing: 'Espacio',
    warpYarnInfo: 'Tela cruda',
    inch: 'Pulgadas',
    cm: 'Centímetros',
    timeSequence: 'Timing',
    needle: 'Agujas',
    yarnSpecification: 'Especificación del hilo',
    yarn: 'Hilo',
    serialNumber: 'Otros máquina No.',
    technician: 'Técnico',
    series: 'Serie de tela',
    fabricType: 'Tipos de tela',
    productFeatures: 'Características del producto',
    inputVoltage: 'Introduzca el voltaje',
    inputCurrent: 'Introduzca amperios',
    electronicWindingTensionUpper: 'Eléctrico. amperio del rodillo (superior)',
    electronicWindingTensionLower: 'Eléctrico. amperio del rodillo (inferior)',
    mechanicalType: 'Meca. Engranaje',
    lowerNeedleDistanceToSeatRing: 'Dist. anillo porta cilindro y leva',
    upperNeedleDistanceToSeatRing: 'Dist. anillo de soporte de dial y leva',
    upperNeedleDistanceToLowerNeedleNozzle: 'El dial de separación y el cilindro se derriban con el borde',
    selectorNeedleRingDistanceToTakeUpPlate: 'Dis. entre el anillo del actuador y el marco',
    seatRingDistanceToTakeUpPlate: 'Dis. entre el anillo portalevas y el marco',
    machineSpeed: 'RPM',
    inverterFrequency: 'Inversor HZ',
    yarnCount: 'CPI',
    gramsPerSquareMeter: 'GSM',
    yardsPerPound: 'G/YD',
    customerYarnWidth: 'Ancho',
    customerSpecifiedYarnLength: 'Longitud de puntada designar',
    newCustomerPackageTiming: 'Sincronización del Sinker',
    doubleSidedCuttingTiming: 'Temporización del dial leva',
    nozzleTiming: 'Sincronización del transportador de hilo',
    yarnCode: 'Código de hilo',
    yarnType: 'Espec. del hilo.',
    color: 'Color',
    yarnSize: 'Conteo de hilo',
    fiberCount: 'Filamento',
    innerFiber: 'Peluza interior',
    outerFiber: 'Peluza superior',
    flatness: 'Nivelación',
    roundness: 'Redondez',
    windPressure: 'Presión del aire',
    appearance: 'Apariencia',
    machineLevel: 'Nivelación del máquina',
    trident: 'Nivelación del dial & redondez',
    highLegWinder: 'Plegador pie alta',
    fabricSlitting: 'Plegador abierta',
    inverterCurrent: 'Amperio inversor',
    machineFunctionFrame: 'Hilo MPF y anillo y filetas',
    inchStart: 'Jog, arranque y parada funcc. Cambio',
    firstSecondSpeed: 'Velocidad, lámpara y ventilador func. Camnbio',
    firstSecondSpeed2: 'Ajuste de velocidad.',
    controllerOtherFunctions: 'Controlador de otras funciones',
    electricalBoxSignals: 'Señales y sensores',
    fanDustRemovalAction: 'Operación del ventilador',
    oilSprayerAction: 'Operación de engrasador',
    airBlowerSystemAction: 'Compresor de aire y operacion',
    windingAction: 'Operacion de systema de plegador',
    machineControllerOperationTutorial: 'Capacitación en operación del panel de control.',
    machineOperationTutorial: 'Entrenamiento de operación M/C',
    other: 'Otros',
    descriptionAndAttachment: 'Referencia',
    upperNeedleArrangement: 'Orden de agujas Dial',
    upperKnifeArrangement: 'Orden de cuchillo Dial',
    lowerNeedleArrangement: 'Orden de agujas cilindro',
    lowerNeedleArrangementShort: 'Orden aguja cilin',
    lowerKnifeArrangement: 'Orden de cuchilla cilíndro',
    lowerKnifeArrangementShort: 'Orden cuchill cilín',
    upperNeedlePlate: 'Dial',
    lowerNeedleCylinder: 'Cilindro',
    blank: 'Espacio',
    blockRule: 'Measure jigs',
    retractionBaseline: 'Sinker Dist. atrás',
    upperPlateNeedleWithdrawalKnob: 'Perilla escala dial',
    upperPlateNeedleWithdrawalDepth: 'Dist. puntada dial',
    upperPlateHalfNeedleHeight: 'Dial Knit, tuck levas Dist.',
    upperPlateFlatNeedleHeight: 'Dial Miss Cam Dist.',
    lowerCylinderFlatNeedleHeight: 'Cilin levas Miss Dist.',
    lowerCylinderFlatNeedleDepth: 'Dist. puntada cilín',
    lowerCylinderNeedleWithdrawalKnob: 'Perilla escala cilin',
    yarnTypeCode: 'Código de hilo',
    yarnTypeTensionN: 'Tensión del hilo (N)',
    cmPer100Needles: 'Puntada / 100N',
    feedYarnLengthPerRevolution: 'Puntada / 1 hilera',
    aluminumPlateYarnFeedingDepthCm: 'Calidad diám. polea(cm)',
    yarnFeedingAluminumPlateScale: 'Calidad marca de polea',
    newCustomerPackage: 'Sinker',
    upperPlate: 'Dial',
    lowerCylinder: 'Cilindro',
    yarnShort: 'Hilo',
    pleaseEnterProductName: 'Ingrese descripción piezas',
    pleaseEnterProductNumber: 'Ingrese No. parte',
    quantity: 'Cantidad',
    damage: 'Roto',
    missing: 'Desaparecido',
    wrong: 'Equivocado',
    pleaseEnterTitle: 'Introduce un título',
    pleaseEnterContent: 'Introducir contenido',
    addQuestionItem: 'Agregar elemento de pregunta',
    questionProcessingRecord: 'Registro de contramedidas',
    pleaseEnterQuestionDescription: 'Ingrese la descripción del problema',
    traineeAndClient: 'Aprendiz / Cliente',
    trainer: 'Entrenador',
    drawingFunction: 'Función CAD',
    upperMachineProgram: 'Progrm máquina',
    UnravelingFunction: 'Análisis tejidos',
    courseName: 'Nombre del curso',
    pleaseEnterCourseName: 'Ingrese el nombre del curso',
    imageName: 'Nombre del archivo de patrón',
    pleaseEnterImageName: 'Ingrese el nombre del archivo de patrón',
    confirmItem: 'Confirmar',
    undone: 'Incompleto',
    pleaseEnterInquire: 'Ingrese nombre del cliente, documento MU',
    machineUtilizationSurvey: 'Utilización de maquinaria',
    customerID: 'Identificación del cliente',
    pleaseEnterCustomerID: 'Introduzca ID del cliente',
    pleaseSelect: 'Seleccionar',
    pleaseEnterSkill: 'Ingrese la habilidad',
    pleaseEnterBuyer: 'Introduzca comprador',
    pleaseEnterRemark: 'Introducir comentario',
    source: 'Fuente',
    selfInput: '自行輸入',
    textileEquipment: 'Máquina de tejer',
    textileMachineBrand: 'Marca maquina de tejer',
    textileMachineType: 'Modelo máquina de tejer',
    notSelected: 'No seleccionado',
    select: 'Seleccionar',
    brand: 'Marca',
    totalMachine: 'Total Máquinas',
    openRate: '% máquina en uso',
    dailyOutput: 'Producc. (T/día)',
    spinning: '紡紗',
    knitting: '針織',
    dyeing: '染整',
    garment: '成衣',
    pleaseEnterProcessingContent: 'Por favor ingrese contenido del ajuste.',
    // alert
    editNotSave: '¿Estás seguro de salir?',
    deleteConfirm: '¿Estás seguro de eliminar?',
    confirmClearSignature: '¿Está seguro de eliminar los datos relacionados con la firma?',
    confirmWriteData: '¿Estás seguro de escribir los datos?',
    confirmCopyToSalesOrder: '¿Está seguro de sobre copiar los datos a este informe?',
    fieldsNotFilledUnableToSend: '尚有欄位未填寫，無法送出。',
    dataWriteComplete: '資料寫入完成。',
    deleteSuccess: 'Eliminación exitosa.',
    clearSuccess: 'Remover exitosa.',
    copySuccess: 'Copia exitosa.',
    selectWorker: 'Por favor seleccione un técnico.',
    selectProblem: 'Por favor seleccione elemento de la pregunta',
    unknownError: 'An unknown error has occurred, please contact customer service.',
    fileTypeError: 'File type mismatch',
    openCameraPermission: 'Please grant camera access first.',
    //new
    selectDate: 'Seleccione fecha',
    yarnTensionN: 'Tensión del hilo (N)',
    category: 'Tipo',
    kind: 'Modelo',
    // pleaseSelectType: 'Seleccione tipo',
    dateInOutError: 'La fecha de finalización del servicio siempre debe ser igual o posterior a la fecha de inicio del servicio.',
    yarnFeedingTeethOrDisc: 'Engranaje/polea',
    changed: 'Cambió',
    pleaseSelectSparePartsStatus: 'Seleccione el estado del accesorio',
    pleaseEnterDuration: 'Tiempo de servicio',

    // API語系
    saveComplete: 'Se guardo con éxito',
    needOnline: 'Need Online.',
    addComplete: 'Añadir con éxito',
    reportCreator: 'Creador de informes',
    onlineGenerate: 'Generate after uploading',
    synchronizeFail: '同步異常',
    synchronizeSuccess: 'Sincronizar exitosamente.',
    downloadFail: '下載異常',
    downloadSuccess: 'Descarga con exito.',
    synchronizeSelect: 'Seleccionar sincronización',
    onlySynchronizeOffData: 'Descarga datos en línea',
    synchronizeData: 'Sincroniza datos desconec',
    synchronizeImage: 'Sincronizar imagen',
    downloadOfflineFile: 'Download OffLine File',
    downloadOfflineData: 'Descargar datos de desconexión',
    downloadOfflineImage: 'Descargar imagen de desconexión',
    synchronizing: 'Sincronizando, favor espere. No cierres la pantalla de la aplicación.',
    downloading: 'Descargando, favor espere. No cierres la pantalla de la aplicación.',
    confirmDownload: '¿Confirmas la descarga? ',
    confirmSynchronization: '¿Confirmas la sincronización? ',
    overwriteOffline : 'La descarga sobrescribirá los datos actuales de desconectado',
    synchronizationOnline: 'La sincronización sincronizará los datos relacionados en línea.',
    uploadFail: '上傳異常',
    fileSzieOverTit: 'The file size is too large.',
    fileSzieOverMes: 'Only files under 50 MB can be uploaded. For files over 50 MB, please upload to the wired version.',

    sortByCreate: 'Organizar por creacion de orden',
    sortByType: 'Organizar por tipo',
    reportDownload: 'informe',
    selectServiceReport: 'Seleccione Informe de Servicio',
    enterServiceReportOrMachine: null,
    selectAll: 'Seleccionar todo',

    downloadHint:null
}
